import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import MUIDataTable from "mui-datatables";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { preparationHours } from "../../../app/utlils";
import { useEffect, useRef } from "react";
import axios from "axios";

export default function ProductVariation({
  variationValue,
  control,
  getSKU,
  weightList,
  getValues,
  setValue,
  onDeleteVariation,
}) {
  const normalizeItem = (item, idx = 0) => {
    const rawId = item?.variation_id ?? item?.id ?? null;
    const rawEggPrep = item?.eggPreparation ?? item?.egg_preparation;
    const rawEgglessPrep = item?.egglessPreparation ?? item?.eggless_preparation;

    const eggPrep =
      rawEggPrep !== undefined &&
      rawEggPrep !== null &&
      rawEggPrep !== 0 &&
      rawEggPrep !== "0" &&
      rawEggPrep !== ""
        ? rawEggPrep
        : "";

    const egglessPrep =
      rawEgglessPrep !== undefined &&
      rawEgglessPrep !== null &&
      rawEgglessPrep !== 0 &&
      rawEgglessPrep !== "0" &&
      rawEgglessPrep !== ""
        ? rawEgglessPrep
        : "";

    return {
      _rowKey:
        item?._rowKey ||
        (rawId ? `id-${rawId}` : `row-${idx}-${Date.now()}-${Math.random()}`),
      id: rawId,
      variation_id: rawId,
      weight: item?.weight ?? item?.weight_id ?? "",
      weight_id: item?.weight_id ?? item?.weight ?? "",
      egg: item?.egg !== undefined && item?.egg !== null ? String(item.egg) : "",
      eggLess:
        item?.eggLess !== undefined && item?.eggLess !== null
          ? String(item.eggLess)
          : item?.eggless !== undefined && item?.eggless !== null
          ? String(item.eggless)
          : "0",
      eggless:
        item?.eggLess !== undefined && item?.eggLess !== null
          ? String(item.eggLess)
          : item?.eggless !== undefined && item?.eggless !== null
          ? String(item.eggless)
          : "0",
      eggPreparation: eggPrep,
      egg_preparation: eggPrep,
      egglessPreparation: egglessPrep,
      eggless_preparation: egglessPrep,
      sku: item?.sku ?? "",
    };
  };

  const getInitialVariation = () => {
    if (Array.isArray(variationValue) && variationValue.length > 0) {
      return variationValue.map((item, idx) => normalizeItem(item, idx));
    }
    return [
      normalizeItem({
        id: null,
        variation_id: null,
        weight: "",
        weight_id: "",
        egg: "",
        eggLess: "0",
        eggless: "0",
        eggPreparation: "",
        egg_preparation: "",
        egglessPreparation: "",
        eggless_preparation: "",
        sku: "",
      }),
    ];
  };

  const [variation, setVariation] = React.useState(getInitialVariation);

  const syncToForm = (list) => {
    const formVariations = list.map((item) => {
      const eggPrep = item?.eggPreparation ?? item?.egg_preparation;
      const egglessPrep = item?.egglessPreparation ?? item?.eggless_preparation;
      return {
        id: item?.id ?? item?.variation_id ?? null,
        variation_id: item?.variation_id ?? item?.id ?? null,
        weight:
          item?.weight !== "" && item?.weight !== undefined
            ? Number(item?.weight)
            : item?.weight_id !== "" && item?.weight_id !== undefined
            ? Number(item?.weight_id)
            : "",
        weight_id:
          item?.weight_id !== "" && item?.weight_id !== undefined
            ? Number(item?.weight_id)
            : item?.weight !== "" && item?.weight !== undefined
            ? Number(item?.weight)
            : "",
        egg: String(item?.egg ?? ""),
        eggLess: String(item?.eggLess ?? item?.eggless ?? "0"),
        eggless: String(item?.eggLess ?? item?.eggless ?? "0"),
        eggPreparation:
          eggPrep === "" || eggPrep === null || eggPrep === undefined
            ? "0"
            : String(eggPrep),
        egg_preparation:
          eggPrep === "" || eggPrep === null || eggPrep === undefined
            ? "0"
            : String(eggPrep),
        egglessPreparation:
          egglessPrep === "" || egglessPrep === null || egglessPrep === undefined
            ? "0"
            : String(egglessPrep),
        eggless_preparation:
          egglessPrep === "" || egglessPrep === null || egglessPrep === undefined
            ? "0"
            : String(egglessPrep),
        sku: item?.sku ?? "",
      };
    });
    setValue("variation", formVariations, {
      shouldDirty: true,
      shouldValidate: false,
    });
  };

  // Sync initial variation to form once on mount if form doesn't have variations yet
  useEffect(() => {
    const currentFormVars = getValues ? getValues("variation") : null;
    if (!currentFormVars || currentFormVars.length === 0) {
      syncToForm(variation);
    }
  }, []);

  const prevVariationKeyRef = useRef("");
  useEffect(() => {
    if (Array.isArray(variationValue) && variationValue.length > 0) {
      const currentKey = variationValue
        .map((v) => v?.variation_id || v?.id || "")
        .join(",");
      if (currentKey && currentKey !== prevVariationKeyRef.current) {
        prevVariationKeyRef.current = currentKey;
        const normalized = variationValue.map((item, idx) =>
          normalizeItem(item, idx)
        );
        setVariation(normalized);
      }
    }
  }, [variationValue]);

  const handleFieldChange = (index, fieldUpdates) => {
    setVariation((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        ...fieldUpdates,
      };
      syncToForm(updated);
      return updated;
    });
  };

  const addVariationHandler = () => {
    const newRow = normalizeItem(
      {
        id: null,
        variation_id: null,
        weight: "",
        weight_id: "",
        egg: "",
        eggLess: "0",
        eggless: "0",
        eggPreparation: "",
        egg_preparation: "",
        egglessPreparation: "",
        eggless_preparation: "",
        sku: "",
      },
      variation.length
    );
    const updated = [...variation, newRow];
    setVariation(updated);
    syncToForm(updated);
  };

  const removeVariations = (index) => {
    const targetItem = variation[index];
    const removedId = targetItem?.variation_id || targetItem?.id;

    if (removedId && !String(removedId).startsWith("temp-")) {
      if (onDeleteVariation) {
        onDeleteVariation(removedId);
      }
      // Also invoke backend delete variations if endpoint exists
      axios.get(`/deleteVariation/${removedId}`).catch(() => {});
      axios.delete(`/variation/${removedId}`).catch(() => {});
    }

    const updated = variation.filter((_, idx) => idx !== index);
    setVariation(updated);
    syncToForm(updated);
  };

  const columns = [
    {
      name: "weight",
      label: "Weight",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const currentItem = variation[dataIndex];
          const currentWeight =
            currentItem?.weight ?? currentItem?.weight_id ?? "";
          return (
            <FormControl fullWidth margin="normal">
              <InputLabel id={`weight_label_${dataIndex}`}>Weight</InputLabel>
              <Select
                labelId={`weight_label_${dataIndex}`}
                id={`variation_weight_${dataIndex}`}
                value={currentWeight}
                label="Weight"
                onChange={(event) => {
                  const selectedValue = event.target.value;
                  const sku = getSKU ? getSKU(selectedValue) : "";
                  handleFieldChange(dataIndex, {
                    weight: selectedValue,
                    weight_id: selectedValue,
                    sku: sku || currentItem?.sku || "",
                  });
                }}
              >
                <MenuItem value="" key={0}>
                  --SELECT--
                </MenuItem>
                {weightList?.map((item) => (
                  <MenuItem value={item?.weight_id} key={item?.weight_id}>
                    {`${item.weight_name} ${item?.unit?.unit_name}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          );
        },
      },
    },
    {
      name: "egg",
      label: "Egg",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const currentItem = variation[dataIndex];
          return (
            <TextField
              fullWidth
              margin="normal"
              label="Egg"
              variant="outlined"
              value={currentItem?.egg ?? ""}
              onChange={(e) =>
                handleFieldChange(dataIndex, { egg: e.target.value })
              }
            />
          );
        },
      },
    },
    {
      name: "eggLess",
      label: "Eggless",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const currentItem = variation[dataIndex];
          return (
            <TextField
              fullWidth
              margin="normal"
              label="Eggless"
              variant="outlined"
              value={currentItem?.eggLess ?? ""}
              onChange={(e) =>
                handleFieldChange(dataIndex, {
                  eggLess: e.target.value,
                  eggless: e.target.value,
                })
              }
            />
          );
        },
      },
    },
    {
      name: "eggPreparation",
      label: "Egg Preparation",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const currentItem = variation[dataIndex];
          const currentPrep =
            currentItem?.eggPreparation ?? currentItem?.egg_preparation ?? "";
          const displayPrep =
            currentPrep === 0 ||
            currentPrep === "0" ||
            currentPrep === "" ||
            currentPrep === null ||
            currentPrep === undefined
              ? ""
              : Number(currentPrep);
          return (
            <FormControl fullWidth margin="normal">
              <InputLabel id={`egg_prep_label_${dataIndex}`}>
                Egg Preparation
              </InputLabel>
              <Select
                labelId={`egg_prep_label_${dataIndex}`}
                id={`variation_egg_prep_${dataIndex}`}
                value={displayPrep}
                label="Egg Preparation"
                onChange={(e) =>
                  handleFieldChange(dataIndex, {
                    eggPreparation: e.target.value,
                    egg_preparation: e.target.value,
                  })
                }
              >
                <MenuItem value="" key="prep-select">
                  --SELECT--
                </MenuItem>
                {preparationHours?.map((item, idx) => (
                  <MenuItem value={item?.id} key={`prep-${item?.id}-${idx}`}>
                    {item?.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          );
        },
      },
    },
    {
      name: "egglessPreparation",
      label: "Eggless Preparation",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const currentItem = variation[dataIndex];
          const currentPrep =
            currentItem?.egglessPreparation ??
            currentItem?.eggless_preparation ??
            "";
          const displayPrep =
            currentPrep === 0 ||
            currentPrep === "0" ||
            currentPrep === "" ||
            currentPrep === null ||
            currentPrep === undefined
              ? ""
              : Number(currentPrep);
          return (
            <FormControl fullWidth margin="normal">
              <InputLabel id={`eggless_prep_label_${dataIndex}`}>
                Eggless Preparation
              </InputLabel>
              <Select
                labelId={`eggless_prep_label_${dataIndex}`}
                id={`variation_eggless_prep_${dataIndex}`}
                value={displayPrep}
                label="Eggless Preparation"
                onChange={(e) =>
                  handleFieldChange(dataIndex, {
                    egglessPreparation: e.target.value,
                    eggless_preparation: e.target.value,
                  })
                }
              >
                <MenuItem value="" key="eggless-prep-select">
                  --SELECT--
                </MenuItem>
                {preparationHours?.map((item, idx) => (
                  <MenuItem
                    value={item?.id}
                    key={`eggless-prep-${item?.id}-${idx}`}
                  >
                    {item?.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          );
        },
      },
    },
    {
      name: "sku",
      label: "SKU",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const currentItem = variation[dataIndex];
          return (
            <TextField
              fullWidth
              margin="normal"
              label="SKU"
              variant="outlined"
              value={currentItem?.sku ?? ""}
              onChange={(e) =>
                handleFieldChange(dataIndex, { sku: e.target.value })
              }
            />
          );
        },
      },
    },
    {
      name: "Delete",
      options: {
        customBodyRenderLite: (dataIndex) => {
          return (
            <div className="actionBtns">
              <Button
                aria-label="delete"
                onClick={() => removeVariations(dataIndex)}
              >
                <DeleteOutlineOutlinedIcon color="error" fontSize="medium" />
              </Button>
            </div>
          );
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    filter: false,
    download: false,
    viewColumns: false,
    print: false,
    pagination: false,
  };

  return (
    <Box
      sx={{
        width: "100%",
        "& .actions": {
          color: "text.secondary",
        },
        "& .textPrimary": {
          color: "text.primary",
        },
      }}
    >
      <MUIDataTable
        className="bg-light"
        data={variation || []}
        columns={columns}
        options={options}
        title={
          <Button
            size="small"
            variant="contained"
            color="secondary"
            onClick={addVariationHandler}
            startIcon={<AddIcon />}
          >
            New Variation
          </Button>
        }
      />
    </Box>
  );
}
